/**
 * 21/10/2026 — a route test's gateways in the formula's order on the
 * Gateways tab: the engine's own ranking (kept at its last pass, once every
 * test drop settled) or the one so far, with the line that says which.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenRouteTestToday } from '@trafficpulse/shared';

import { instantText } from '../../../utils/clock/dk-label';
import { RankingTable } from '../../shared/route-test/RankingTable';
import { progressWords, rankingHeadline } from '../../shared/route-test/ranking-words';
import { useCountryClock } from '../../shared/time/country-clock-context';

export const RankingBlock: FC<{ test: DropGenRouteTestToday }> = ({ test }) => {
  const clock = useCountryClock();
  const r = test.ranking;
  if (!r) return null; // an older server answer has no ranking
  const line = rankingHeadline(r, { at: r.at ? instantText(r.at, clock) : null, progress: progressWords(test.drops.settled, test.drops.planned, 'settled') });
  return (
    <div className="mx-5 mb-2 flex flex-col gap-1.5" data-testid="route-test-ranking-block">
      <p className="text-[11px] text-muted-foreground" data-testid="route-test-ranking-line">
        {line}
      </p>
      {r.rows.length > 0 ? (
        <RankingTable rows={r.rows} won={test.state === 'won'} className="rounded-lg border border-border/50" />
      ) : (
        <p className="text-xs text-muted-foreground" data-testid="route-test-ranking-note">
          {r.note}
        </p>
      )}
    </div>
  );
};
